import { useQuery } from '@tanstack/react-query';
import { getBrands } from '../../api/brands/getBrands';
import { useState } from 'react';

export const useGetBrands = (params?: Record<string, string | number>) => {
  const [page, setPage] = useState(1);

  const { data, isSuccess, isLoading, refetch } = useQuery({
    queryKey: ['getBrands', page],
    queryFn: () => getBrands({ page, ...params }),
  });

  return {
    brandsData: data,
    isGetBrandsSuccess: isSuccess,
    isGetBrandsLoading: isLoading,
    brandsRefetch: refetch,
    setPage,
    page,
  };
};
